import React, {useEffect, useMemo, useState} from 'react';
import MaterialReactTable, {MRT_ColumnDef, MRT_Row, MRT_TableInstance} from 'material-react-table';
import {EuiProgress} from "@elastic/eui";
import "./Topbar.css"
interface Credit {
    creditId: number;
    creditTransaction: number;
    date: string;
}

const CreditMenuComponent: React.FC = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [credits, setCredits] = useState<Credit[]>([]);


    useEffect(() => {
        const fetchCredits = async () => {
            try {
                // Get the token from local storage
                const token = localStorage.getItem('token');

                // Make the API call with the bearer token
                const response = await fetch('/api/v1/credit', {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                if (response.ok) {
                    const data = await response.json();
                    setCredits(data);
                } else {
                    console.error('API Error:', response.status);
                }
            } catch (error) {
                console.error('Error:', error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchCredits();
    }, []);

    const columns = useMemo<MRT_ColumnDef<Credit>[]>(
        () => [
            {
                header: 'Id',
                accessorKey: 'creditId',


            },{
                header: 'Transaction amount',
                accessorKey: 'creditTransaction'
            },
            {
                header: 'date',
                accessorKey: 'date',
                //  enableGrouping: false, //do not let this column be grouped

            },


        ],
        [],
    );





    return (
        <>
            <div className="top-bar-inside">
                <div className="containeroftopbar">
                    <div className="logo-inside">Credit History</div>
                </div>
            </div>
            {isLoading ?  <EuiProgress size="xs" color="accent" />:(
            <MaterialReactTable
                enablePagination={false}
                columns={columns}
                data={credits}
                enableGrouping
                enableStickyHeader
                enableStickyFooter
                enablePinning
                enableColumnOrdering = {true}
                enableExpandAll={true}

                initialState={{

                    density: 'compact',

                    //   grouping: ['ad_unit_id','ad_type'],
                    //   grouping: ['date', 'ad_type'], //group by location and department by default and expand grouped rows
                    /*  expanded: {
                            1: true,
                            2:true,
                            3:true,
                            4:false,
                            5:false,
                            6:false,
                            7:false,
                            8:false,
                            9:false,
                            10:false,
                            11:false

                        },*/
                    // expanded: true,

                }
                }

                muiToolbarAlertBannerChipProps={{ color: 'primary' }}
                muiTableContainerProps={{ sx: { maxHeight: 700 } }}
            />)}
        </>
    );
};

export default CreditMenuComponent;